"use client";
import CheckInForm from "./CheckInForm";
import LayoutWrapper from "./LayoutWrapper";
import PnrForm from "./PnrForm";
import Form from "./form";

const HotelSearchFormWrapper = (props) => {
  return (
    <LayoutWrapper
      pnrFormComponent={PnrForm}
      checkInFormComponent={CheckInForm}
      translationNamespace="common"
      hidePnrSection={props.hidePnrSection}
      showCampaignSection={props.showCampaignSection}
      wrapperClassName={props.wrapperClassName}
    >
      <Form
        {...props}
        autoSelectFirstWhenClosed={props.autoSelectFirstWhenClosed}
        viewportHeightWrapperActive={props.viewportHeightWrapperActive}
      />
    </LayoutWrapper>
  );
};

export default HotelSearchFormWrapper;
